import { Component, OnInit, Inject } from '@angular/core';
import { ManageComponentsService } from '../manage-components.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-upload-comp-image',
  templateUrl: './upload-comp-image.component.html',
  styleUrls: ['./upload-comp-image.component.scss']
})
export class UploadCompImageComponent implements OnInit {

  selectedFile: File;
  form: FormGroup;
  loading: boolean = false;
  ngOnInit(): void {
    if(this.data.attachment)
    this.attachment =  this.data.attachment;
    this.tool_auto=this.data.tool_auto;
    this.isStandard=this.data.isStandard;
  }

  public attachment;
  public imageName;
  public tool_auto;

  ImageLoading: boolean = false
  constructor(private fb: FormBuilder,
    private _sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<UploadCompImageComponent>,
    public _componentservice: ManageComponentsService,
    private _notify: NotificationsService,
    @Inject(MAT_DIALOG_DATA)
    public data: any


  ) { }

  //Dialog close
  NoClick(): void {
    this.data = ''
    this.dialogRef.close();
  }

  //upload image
  uploadPhoto(newPhoto: string) {

    this.attachment = newPhoto.split(",")[1];
    this.data.attachment = this.attachment;
    this.data.imageName = this.selectedFile.name;
  }


  //select image from computer
  onSelectPhoto(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.selectedFile = event.target.files[0];
      reader.onloadend = (e) => {
        this.uploadPhoto(reader.result as string);
        
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  sanitize(image: string) {
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  }
  isStandard:boolean=false;
  //change image
  changeAttachImage=()=>
  {
    this.attachment = ''
    console.log("itthis.data.componetImageResultem",this.data.componetImageResult)
    if (this.data.componetImageResult) {
    this.data.componetImageResult.map(item=>{
      console.log("item",item)
      if( item.tool_auto == this.tool_auto)
      {
         this.attachment = item.attachment;
         this.isStandard=item.isStandard;
      }
      this.data.tool_auto = this.tool_auto;
     
     });
    }
  }

  saveCompTestingPointtImageDialog() {
    console.log("attachment_comp", this.data)
    this._componentservice.saveCompartImage(this.data.compart_attach_auto, this.data.compartid_auto, 2, 0, this.data.comparttype_auto, this.tool_auto, 0, this.attachment, this.imageName, this.data.modified_user)
    .subscribe(response => {
      if (response) {
        this._notify.success('Saved', 'Component Testing Image ');
      } else {
        this._notify.error('Error', 'Unable to save the Component image. Please contact TrackTreads support.');
      }
      this.dialogRef.close();
    });
  }

}
